var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert-management_container"},[_c('organism-alert-management',{attrs:{"alertData":_vm.alertData},on:{"toggleAlert":_vm.toggleAlert}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }